import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faPlug } from "@fortawesome/free-solid-svg-icons";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { faSun } from '@fortawesome/free-solid-svg-icons';
import { faBatteryEmpty } from "@fortawesome/free-solid-svg-icons";
import { faBatteryQuarter } from "@fortawesome/free-solid-svg-icons";
import { faBatteryHalf } from "@fortawesome/free-solid-svg-icons";
import { faBatteryThreeQuarters } from "@fortawesome/free-solid-svg-icons";
import { faBatteryFull } from "@fortawesome/free-solid-svg-icons";
import api from '../../apis/EdisonApi';
import { toast } from "react-toastify";

const Zucchetti = () => {

    const [status, setStatus] = useState('NA');

    useEffect(() => {
        const controller = new AbortController();
        getStatus();

        return () => {
            controller.abort();
        };
    }, []);

    const getStatus = async () => {
        let config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: localStorage.getItem('idToken')
            },
        };

        try {
            const resp = await api.get('/zucchetti/status', config);
            let res = resp.data.rawdata;
            res["lastRequest"] = resp.data.timestamp;
            setStatus(res);
        } catch(err) {
            toast.error('API error, please refresh the page');
        }
    };

    const renderPowerPV = () => {
        if (status === 'NA') {
            return <div className="count">NA</div>;
        } else {
            return <div className="count">{ status.powerPV } W</div>;
        } 
    };

    const renderConsumption = () => {
        if (status === 'NA') {
            return <div className="count">NA</div>;
        } else {
            return <div className="count">{ status.powerConsumed } W</div>;
        }
    };

    const renderBatteryIcon = () => {
        if (status === 'NA') {
            return <div className="icon"><FontAwesomeIcon icon={faBatteryEmpty} size="3x" /></div>;
        } else if (status.batterySoC > 75) {
            return <div className="icon"><FontAwesomeIcon icon={faBatteryFull} size="3x" /></div>;
        } else if (status.batterySoC > 50) {
            return <div className="icon"><FontAwesomeIcon icon={faBatteryThreeQuarters} size="3x" /></div>;
        } else if (status.batterySoC > 25) {
            return <div className="icon"><FontAwesomeIcon icon={faBatteryHalf} size="3x" /></div>;
        } else if (status.batterySoC > 0) {
            return <div className="icon"><FontAwesomeIcon icon={faBatteryQuarter} size="3x" /></div>;
        } else {
            return <div className="icon"><FontAwesomeIcon icon={faBatteryEmpty} size="3x" /></div>;
        }
    };

    const renderBatterySoc = () => {        
        if (status === 'NA') {
            return <div className="count">NA</div>;
        } else {
            return (                
                <div className="count">{status.batterySoC}%</div>
            );           
        }
    };

    const renderDetails = () => {                    

        if (status === 'NA')  {
            return (
                <div className="x_content">
                    <div>Device ID: zcs1</div>
                    <div>Power Production (powerGenerating): NA</div>
                    <div>Power Consumption (powerConsuming): NA</div>
                    <div>Battery (batterySoC): NA</div>
                    <div>Battery Discharge (powerDischarging): NA</div>
                    <div>Self Consumption (powerAutoconsuming): NA</div>
                    <div>Power Importing: NA</div>
                    <div>Power Exporting: NA</div>
                    <div>Power Charging: NA</div>
                    <div>Power Generating: NA</div>
                    <div>Last Update (lastUpdated): NA</div>
                    <div>Last Request (ts): NA</div>
                </div>
            );
        } else {
            let lastDate = new Date(status.lastRequest);

            return (
                <div className="x_content">
                    <div>Device ID: zcs1</div>
                    <div>Power Production (powerGenerating): {status.powerPV} W</div>
                    <div>Power Consumption (powerConsuming): {status.powerConsumed} W</div>
                    <div>Battery (batterySoC): {status.batterySoC}%</div>
                    <div>Battery Discharge (powerDischarging): {status.batteryDischarge} W</div>
                    <div>Self Consumption (powerAutoconsuming): {status.selfconsumptionPower} W</div>
                    <div>Power Importing: {status.powerImporting} W</div>
                    <div>Power Exporting: {status.powerExporting} W</div>
                    <div>Power Charging: {status.powerCharging} W</div>
                    <div>Power Generating: {status.powerGenerating} W</div>
                    <div>Last Update (lastUpdated): {status.lastUpdated}</div>
                    <div>Last Request (lastRequest): {lastDate.toLocaleString()}</div>
                </div>
            );
        }                                                   
    };

    return (
        <div className="right_col" role="main">
            <header className="page-heading device-page-heading">
                <div>
                    <p className="eyebrow">CONNECTED DEVICE</p>
                    <h1>Zucchetti</h1>
                </div>
            </header>

            <div className="page-title">
                <div className="row top_tiles">
                    <div className="animated flipInY col-lg-4 col-md-4 col-sm-12 col-xs-12">
                        <div className="tile-stats">
                            <h3>Power Production</h3>
                            <div className="icon"><FontAwesomeIcon icon={faSun} size="3x" /></div>
                            { renderPowerPV() }              
                        </div>
                    </div>
                    <div className="animated flipInY col-lg-4 col-md-4 col-sm-12 col-xs-12">
                        <div className="tile-stats">
                            <h3>Power Consumption</h3>
                            <div className="icon"><FontAwesomeIcon icon={faPlug} size="3x" /></div>
                            { renderConsumption() }
                        </div>
                    </div>            
                    <div className="animated flipInY col-lg-4 col-md-4 col-sm-12 col-xs-12">
                        <div className="tile-stats">
                            <h3>Battery</h3>       
                            { renderBatterySoc() }
                            { renderBatteryIcon() }
                        </div>
                    </div>
                </div>
            </div>


            <div className="row">
                <div className="col-xs-12">
                    <div className="x_panel">
                        <div className="x_title">
                            <h2>Details</h2>
                            <ul className="nav navbar-right panel_toolbox">
                                <li><span id="collapse-link-details" className="collapse-link"><FontAwesomeIcon icon={faChevronUp} size="lg" /></span>
                                </li>
                                <li><span className="close-link"><FontAwesomeIcon icon={faClose} size="lg" /></span>
                                </li>
                            </ul>
                            <div className="clearfix"></div>
                        </div>

                        { renderDetails() }

                    </div>
                </div>
            </div>
        </div>
    );
};

export default Zucchetti;
